export default __webpack_public_path__ + "images/e422c232e801ce7a4b0d7d9c541945c6.png";